import React, { useDeferredValue, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useGroups from "../../../hooks/useGroups";
import StyledGroupPage from "./styles";

import GroupList from "../../../components/group-list";

const GroupsHomePage = () => {
  const { queryGroup } = useSelector((state) => state.search);
  const deferredQuery = useDeferredValue(queryGroup);
  const navigate = useNavigate();
  const groups = useGroups();

  const finalGroups = useMemo(() => {
    const filterGroups = (g, query) => {
      if (!query) return g;
      return g.filter((g) =>
        g.name.toLowerCase().includes(query.toLowerCase())
      );
    };
    return filterGroups(groups, queryGroup);
  }, [groups, deferredQuery]);

  const onGroupClickHandler = (group) => {
    const id = group?.id;

    if (id) {
      navigate(`/grupo/${id}`);
    }
  };

  return (
    <StyledGroupPage>
      <div className="groups-home-page">
        {finalGroups && (
          <GroupList groups={finalGroups} onGroupClick={onGroupClickHandler} />
        )}
      </div>
    </StyledGroupPage>
  );
};

export default GroupsHomePage;
